import { __read, __spread } from "tslib";
import { formatValue as valueFormatter, } from '@keen.io/charts-utils';
import { KEEN_TABLE_INTERVAL, KEEN_KEY } from '@keen.io/parser';
import { VALUE } from '../../constants';
export var defaultTransformation = function (data, keys, formatValue) {
    var _a = __read(keys, 1), valueSelector = _a[0];
    var columns = [KEEN_TABLE_INTERVAL, VALUE];
    return __spread([
        columns
    ], data.map(function (item) { return [
        item[KEEN_KEY],
        valueFormatter(item[valueSelector], formatValue),
    ]; }));
};
